module.exports = __webpack_public_path__ + "img/mgtotaal.193048e5.svg";